import { render, staticRenderFns } from "./MessagesToCustomers.vue?vue&type=template&id=4295607a&"
import script from "./MessagesToCustomers.vue?vue&type=script&lang=ts&"
export * from "./MessagesToCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesToCustomers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports